import {Condition, Conditions} from "../@types/Query";


export const isCondition = (value: Conditions | Condition): value is Condition => {
    return value.hasOwnProperty("field") &&
        value.hasOwnProperty("value") &&
        value.hasOwnProperty("compare");
}


export const isConditions = (value: Conditions | Condition): value is Conditions => {
    return value.hasOwnProperty("relation") &&
        value.hasOwnProperty("entries");
}